import { message, WidgetUtilsContext } from '@homemaster/jslib'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { zhCN as muiZhCN } from '@mui/x-date-pickers/locales'
import { LicenseInfo } from '@mui/x-license'
import { zhCN } from 'date-fns/locale'
import { useEffect } from 'react'
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'
import MainWindow from './MainWindow'
import CouponTemplatesPage from './pages/CouponTemplatesPage'
import DashboardPage from './pages/DashboardPage'
import EditSitePage from './pages/EditSitePage'
import OrdersPage from './pages/OrdersPage'
import SettingsPage from './pages/SettingsPage'
import SitesPage from './pages/SitesPage'
import SlotsPage from './pages/SlotsPage'
import SlotTemplatePage from './pages/SlotTemplatePage'
import StaffPage from './pages/StaffPage'
import SystemTestPage from './pages/SystemTestPage'
import widgetUtils from './widgetUtils'

// register MUI-X license key, expires on Jan. 24, 2027
LicenseInfo.setLicenseKey(
  'd429561d7b3bdc7e88cdeabeb9ccc83eTz0xMjM3MzgsRT0xODAwODM1MTk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj0yMDIyLEtWPTI=',
)

const router = createBrowserRouter([
  {
    path: '/',
    element: <MainWindow />,
    children: [
      { index: true, element: <Navigate to="/slots" replace /> },
      { path: 'dashboard', element: <DashboardPage /> },
      { path: 'slots', element: <SlotsPage /> },
      { path: 'orders', element: <OrdersPage /> },
      { path: 'slot-templates', element: <SlotTemplatePage /> },
      { path: 'sites', element: <SitesPage /> },
      { path: 'staff', element: <StaffPage /> },
      { path: 'coupon-templates', element: <CouponTemplatesPage /> },
      { path: 'site/:siteId/edit', element: <EditSitePage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'test', element: <SystemTestPage /> },
    ],
  },
])

function AppMain() {
  useEffect(() => {
    message.init()
  }, [])

  return (
    <WidgetUtilsContext value={widgetUtils}>
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={zhCN}
        localeText={muiZhCN.components.MuiLocalizationProvider.defaultProps.localeText}
      >
        <RouterProvider router={router} />
      </LocalizationProvider>
    </WidgetUtilsContext>
  )
}

export default AppMain
